import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Badge, SignOutIcon } from '@motorway/mw-highway-code';

import cypressIds from 'CypressId';

import { SP_HEADER_EVENTS } from 'Utilities/analytics/analyticsHeader';
import { applyCypressData } from 'Utilities/index';

import { getReferBannerLink } from '../checkerPages/Pages/CheckerRouter.utils';

import LocalTexts from './HeaderTexts.json';
import { NavItem, NavVariant } from './NavItem';
import { NavRoute } from './useHeaderNav';

import styles from './Header.scss';

const LocalT = new MDText(LocalTexts);
const t = (key: string) => LocalT.translate(key) as string;

type NavTreeProps = {
  activeGroup: string | null;
  fireMenuHoverTracking: (message: string, name?: string) => void;
  fireTrackingEventForLink: (path: string, name: string) => void;
  handleOnLogOutClick: (e: React.MouseEvent) => void;
  isExternalLink: (route: string) => boolean;
  isUser: boolean;
  navRoutes: NavRoute[];
  setActiveGroup: (group: string | null) => void;
  variant: NavVariant;
};

export const NavTree = ({
  activeGroup,
  fireMenuHoverTracking,
  fireTrackingEventForLink,
  handleOnLogOutClick,
  isExternalLink,
  isUser,
  navRoutes,
  setActiveGroup,
  variant,
}: NavTreeProps) => {
  const items = navRoutes.map((route) => (
    <NavItem
      key={`navlink-${route.name}-${route.path}-${route.label}`}
      {...{
        activeGroup,
        fireMenuHoverTracking,
        fireTrackingEventForLink,
        isExternalLink,
        route,
        setActiveGroup,
        variant,
      }}
    />
  ));

  if (variant === 'desktop') {
    return <ul {...applyCypressData(cypressIds.menus.desktopMenu)}>{items}</ul>;
  }

  return (
    <>
      <ul {...applyCypressData(cypressIds.menus.mobileMenu)}>{items}</ul>
      {isUser && (
        <div className={cx(styles.navItem)}>
          <Link
            className={styles.referLink}
            onClick={() => SP_HEADER_EVENTS.HEADER_LINK_CLICKED({ label: 'mobile_navigation', name: 'refer', url: getReferBannerLink('mobile_navigation') })}
            to={getReferBannerLink('mobile_navigation')}
          >
            { t('navigation.referLabel') }
            <Badge text={t('navigation.referValue')} variant='success' />
          </Link>
        </div>
      )}
      {isUser && (
        <div className={cx(styles.navItem, styles.navItemSignOut)}>
          <a href='#signout' onClick={handleOnLogOutClick}>
            <SignOutIcon />
            { t('navigation.signOutLabel') }
          </a>
        </div>
      )}
    </>
  );
};
